export default {
    mainContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent:'center', 
        gap: '10px',
        marginBottom: '20px'
    },
    actionButton: {
        width: '50%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '10px 20px'
    }
}